"use client";
import React from "react";
import { useMutation, useQuery } from "@apollo/client/react";
import { faStar as farStar } from "@fortawesome/pro-regular-svg-icons";
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "@/components/button";
import { GET_FOLLOWS } from "@/gql/queries/follows";
import { MUTATE_FOLLOWING } from "@/gql/queries/mutations/mutate-following";

import { useCurrentUser } from "../user-context-provider/user-context-provider";

const FollowButton = ({ userId }: { userId: string }) => {
  const currentUser = useCurrentUser();
  const [mutateFollow] = useMutation(MUTATE_FOLLOWING);

  const { data } = useQuery(GET_FOLLOWS, { variables: { userId } });

  if (!currentUser?.id) return null;
  if (currentUser.id === userId) return null;

  const onFollowPressed = (follow: boolean) => {
    mutateFollow({ variables: { userId, following: follow } });
  };

  if (data?.follows?.isFollowing) {
    return (
      <Button
        onClick={() => onFollowPressed(false)}
        type="highlight"
        className="mt-1"
      >
        Following <FontAwesomeIcon icon={faStar} />
      </Button>
    );
  }

  return (
    <Button onClick={() => onFollowPressed(true)} className="mt-1">
      Not following <FontAwesomeIcon icon={farStar} />
    </Button>
  );
};

export default FollowButton;
